export default {
  site_name: "猫咪社区",
  site_slogan: "爱猫人的温暖聚集地",
  home: "首页",
  category: "分类",
  about: "关于我们",
  read_more: "阅读全文",
  view_all: "查看全部",
  search_placeholder: "搜索你感兴趣的猫咪话题...",
  back_to_home: "返回首页",
  breadcrumb_home: "首页",
  article_list: "文章列表",
  related_articles: "相关推荐",
  read_count: "阅读",
  like_count: "赞",
  comment_count: "评论",
  published_on: "发布于",
  by_author: "作者",
  tags: "标签",
  page_not_found: "页面未找到",
  loading: "加载中...",
  scroll_top: "回到顶部",
};